<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!-- <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item> -->

      <el-form-item label="设置报价可选尺寸" prop="is_coupon">
  
        <div class="common-level-rail"><el-button size="small" icon="el-icon-plus" @click="addClick">添加尺寸</el-button></div>
        <div class="pb50">

          <div>
          例如：
            <div>1厘米就是0.01米</div>
            <div>1厘米就是10毫米</div>
            <div>1厘米就是0.1分米</div>
        </div>

        <el-table size="small" :data="form.tableData" border>


          <el-table-column label="固定值" >
            <template slot-scope="scope">
              <el-input v-model="scope.row.num"  :disabled="true"></el-input>
            </template>
          </el-table-column>



          <el-table-column label="尺寸" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.size" ></el-input>
              </template>
            </el-table-column>

         
            <el-table-column label="值（等于多少厘米）" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.propo" type="number"></el-input>
        
              </template>
            </el-table-column>


            <el-table-column label="结果" >
              <template slot-scope="scope">
                {{ scope.row.num }}{{ scope.row.size }} = {{ scope.row.propo }}cm
        
              </template>
            </el-table-column>


            

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.$index)" type="text" size="small" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
      
               
        </div>
    
      </el-form-item>
     

    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import Hproduct_formulaApi from '@/api/hproduct_formula.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        tableData:[]
      },
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*关闭弹窗*/
    addClick(e) {
      let param = {};
      param.size = "";
      param.propo = 0;
      param.num = 1;

      this.form.tableData.push(param);
    },
    deleteClick(index){
      this.form.tableData.splice(index,1);
    },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Hproduct_formulaApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          if( !self.form.tableData){
            self.form.tableData = [];
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Hproduct_formulaApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hproduct_formula/setting/getSetting.vue